module.exports = __webpack_public_path__ + "img/ignis2021.093dcf7c.png";